"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lines = require("@vds-core/lines");
var propTypes = {
  /**
   * Type of the line that will be displayed.
   */
  type: _propTypes["default"].oneOf(["heavy", "light", "xLight", "accent"]),
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool
};
var defaultProps = {
  type: "heavy",
  inverted: false
};
var Line = function Line(props) {
  var type = props.type;
  return /*#__PURE__*/_react["default"].createElement(_lines.Line, (0, _extends2["default"])({}, props, {
    surface: props.inverted ? "dark" : "light",
    type: type === "heavy" || type === "light" || type === "xLight" || type === "accent" ? type : "heavy"
  }));
};
Line.propTypes = propTypes;
Line.defaultProps = defaultProps;
var _default = exports["default"] = Line;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/lines/dist/cjs/components/Line.js
// module id = 1462
// module chunks = 0